<div class="mb-3">
	<div class="hyperion-t6 mb-2"><b [innerHtml]="title"></b></div>
	<p [innerHtml]="content"></p>
</div>
